<template>
  <div class="bg_white">
    <van-nav-bar title="上传资料" left-text="" left-arrow @click-left="onClickLeft" @click-right="onClickRight">
      <template #right>
        <van-icon name="service-o" size="20" />
      </template>
    </van-nav-bar>
    <!-- 2寸照片 -->
    <van-cell-group>
      <template #title>
        <span class="title">白底2寸彩照：</span>
      </template>
      <div class="pd16 flex upImg">
        <van-uploader v-model="file1" multipart :max-count="1" upload-text="白底2寸彩照" :before-read="beforeRead" :after-read="afterRead">
          <span class="iconfont" style="font-size:110px;color: #cccccc;">&#xe647;</span>
        </van-uploader>
        <div class="testImg" style="width: 150px;">
          <img src="../../asset/images/photo_example2.png" alt="">
          <span>参考图</span>
        </div>
      </div>
      
    </van-cell-group>

    <!-- 身份证复印件 -->
    <van-cell-group>
      <template #title>
        <span class="title">身份证复印件：</span>
      </template>
      <div class="pd16 flex upImg">
        <van-uploader v-model="file2" multipart :max-count="1" upload-text="身份证复印件" :before-read="beforeRead" :after-read="afterRead1">
          <span class="iconfont" style="font-size:110px;color: #cccccc;">&#xe647;</span>

        </van-uploader>
        <div class="testImg" >
          <img src="../../asset/images/card_example.png" alt="">
          <span>参考图</span>
        </div>

      </div>
    </van-cell-group>

    <!-- 学历证件照 -->
    <van-cell-group >
      <template #title>
        <span class="title">学历复印件：</span>
      </template>
      <div class="pd16 flex upImg">
        <van-uploader v-model="file4" multipart :max-count="1" upload-text="学历复印件" :before-read="beforeRead" :after-read="afterRead3">
          <span class="iconfont" style="font-size:110px;color: #cccccc;">&#xe647;</span>
        </van-uploader>
      </div>
    </van-cell-group>
    <!-- 证书正面照 -->
    <van-cell-group >
      <template #title>
        <span class="title">证书正面照片：</span>
      </template>
      <div class="pd16 flex upImg">
        <van-uploader v-model="file5" multipart :max-count="1" upload-text="证书正面照片" :after-read="afterRead4">
          <span class="iconfont" style="font-size:110px;color: #cccccc;">&#xe647;</span>
        </van-uploader>
      </div>
    </van-cell-group>

    <!-- 证书反面照片 -->
    <van-cell-group >
      <template #title>
        <span class="title">证书反面照片：</span>
      </template>
      <div class="pd16 flex upImg">
        <van-uploader v-model="file6" multipart :max-count="1" upload-text="证书反面照片" :after-read="afterRead5">
          <span class="iconfont" style="font-size:110px;color: #cccccc;">&#xe647;</span>
        </van-uploader>
      </div>
    </van-cell-group>

    <div class="pd16 m40">
      <van-button class="btn_bg" round block type="default" size="large" @click="onSubmit">提交</van-button>
    </div>


  </div>
</template>

<script>

import * as imageConversion from 'image-conversion'
import { upload } from "../../api/upload"
import {upPhoto,getPhoto} from "../../api/custom"
export default {
  data() {
    return {
      param: {
        studentPhoto: '',
        idCardPhoto:'',
        eduPhoto:'',
        cerPhoto1:'',
        cerPhoto2:'',

      },
      file1: [],
      file2: [],
      file4: [],
      file5: [],//证书正面
      file6: [],//证书反面
    }

  },
  created(){
    this.getPo();
  },
  methods: {
    getPo(){
      getPhoto().then(res=>{
        console.log(res)
        //2寸彩照
        if (res.data.result.studentPhoto != ''  &&res.data.result.studentPhoto != null) {
            this.file1 = [{
              url: this.common.getImageUrl(res.data.result.studentPhoto),
            }]

          }

          //身份证彩照
          if (res.data.result.idCardPhoto != '' && res.data.result.idCardPhoto != null) {
            this.file2 = [{
              url: this.common.getImageUrl(res.data.result.idCardPhoto),
            }]
          }

          //学历
          if (res.data.result.eduPhoto != ''  &&res.data.result.eduPhoto!= null) {
            this.file4 = [{
              url: this.common.getImageUrl(res.data.result.eduPhoto),
            }]
          }

          //证书正面
          if (res.data.result.cerPhoto1 != ''  &&res.data.result.cerPhoto1!= null) {
            this.file5 = [{
              url: this.common.getImageUrl(res.data.result.cerPhoto1),
            }]
          }

          //证书反面
          if (res.data.result.cerPhoto2 != ''  &&res.data.result.cerPhoto2!= null) {
            this.file6 = [{
              url: this.common.getImageUrl(res.data.result.cerPhoto2),
            }]
          }

      })
    },
    onSubmit(){
      let that=this
      upPhoto(this.param).then(res=>{
        if(res.success){
          that.$toast({
            type:'success',
            message:"上传成功",
       
            onClose:()=>{
              that.$router.back()
            }

          })
        }
      })
    },

    //校验图片的格式
    beforeRead(file) {
      let This = this
      // Array.isArray 是用来校验你是单张图片还是数组的形象做校验
      // 这是多张图片上传
      if (Array.isArray(file)) {
        file.forEach(item => {
          if (!item.type.startsWith('image')) {
            This.$toast("请上传图片！")
            return false
          } else if (item.size > 10485760) {
            This.$toast("图片超过10M！")
            return false
          }
        })
      } else {
      // 这是单张图片校验
        if (!file.type.startsWith('image')) {
          This.$toast("请上传图片！")
          return false
        }
        if (file.size > 10485760) {
          This.$toast("图片超过10M！")
          return false
        }
      }
      // 上传之前校验
      return new Promise((resolve, reject) => {
        // console.log('压缩前', file) // 压缩到400KB,大于400KB的图片都会进行压缩，小于则不会
        // 500是控制压缩大小的 根据你自己的需要调整 数值越小压缩越小
        imageConversion.compressAccurately(file, {
            size:300,
            scale: 0.6,
        } ).then(res => {
          res = new File([res], file.name, { type: res.type, lastModified: Date.now() })
          // console.log('压缩后', res)
          resolve(res)
        }).catch(err=>{
          reject(err)
        })
      })
    },

    //2寸免冠照
    afterRead(file) {
    
      let that = this
      file.status = 'uploading';
      file.message = 'uploading...';
      upload(file).then(res => {
        console.log(res)
        let resp = res.data;
        if (resp.success) {
          that.param.studentPhoto = resp.data.fileName;
          file.status = 'success';
          file.message = 'success'
          console.log(that.param.studentPhoto)
        }
      })
    },
    //身份证上传
    afterRead1(file) {
      let that = this
      file.status = 'uploading';
      file.message = 'uploading...';
      upload(file).then(res => {
        console.log(res)
        let resp = res.data;
        if (resp.success) {
          that.param.idCardPhoto = resp.data.fileName;
          file.status = 'success';
          file.message = 'success'
          console.log(that.param.idCardPhoto)
        }

      })
    },
    //学历证书
    afterRead3(file) {
      let that = this
      file.status = 'uploading';
      file.message = 'uploading...';
      upload(file).then(res => {
        console.log(res)
        let resp = res.data;
        if (resp.success) {
          that.param.eduPhoto = resp.data.fileName;
          file.status = 'success';
          file.message = 'success'
          console.log(that.param.eduPhoto)
        }

      })
    },

    //证书正面
    afterRead4(file) {
      let that = this
      file.status = 'uploading';
      file.message = 'uploading...';
      upload(file).then(res => {
        console.log(res)
        let resp = res.data;
        if (resp.success) {
          that.param.cerPhoto1 = resp.data.fileName;
          file.status = 'success';
          file.message = 'success'
          console.log(that.param.healthPhoto)
        }

      })
    },
    //证书反面
    afterRead5(file) {
      let that = this
      file.status = 'uploading';
      file.message = 'uploading...';
      upload(file).then(res => {
        console.log(res)
        let resp = res.data;
        if (resp.success) {
          that.param.cerPhoto2 = resp.data.fileName;
          file.status = 'success';
          file.message = 'success'
          console.log(that.param.healthPhoto)
        }

      })
    },
    onClickLeft() {
      this.$router.back()
    },
    onClickRight() {
      this.$router.push("/online")
    },

  }

};
</script>

<style lang="less">
.testImg{
  width: 80px;
  margin-left: 10px;
  padding: 4px 0;
  span{
    display: block;
    text-align: center;
  }
  img{
    width: 100%;
  }
}
</style>

